import { Loader2 } from "lucide-react";
import styles from "./LoaderSpinner.module.css";

/* Loading spinner component */
export function LoaderSpinner() {
  return (
    <div className={styles.loaderContainer}>
      <Loader2 className={styles.spinnerIcon} size={32} />
    </div>
  );
}
